<template>
    <vs-dropdown v-if="$slots.default" class="cursor-pointer" vs-trigger-click >

        <vs-button
                class="py-3 px-4 flex items-end justify-center content-center text-lg shadow-drop"
                color="primary">
            <span class="mr-2 leading-none">{{ $t('Actions') }}</span>
            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4"/>
        </vs-button>

        <vs-dropdown-menu class="actions-dropdown">
            <slot></slot>
        </vs-dropdown-menu>
    </vs-dropdown>
</template>

<script>
  export default {
    name: "GridActionsMenu"
  }
</script>

<style scoped>

</style>
